"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimezoneSelector = exports.getTimeZones = exports.getTimeZoneWithOffsetString = exports.getTimeZoneOffsetText = exports.getTimezoneInformation = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const moment_timezone_1 = tslib_1.__importDefault(require("moment-timezone"));
const customTimezoneList_1 = require("../../../features/NotificationsSettings/types/customTimezoneList");
const translations_1 = require("../types/translations");
const trackingIds = {
    timeZoneSelector: 'notification_settings-settings-timezone_selector',
};
const getTimezoneInformation = (timezoneIdentifier) => {
    const dateTimeObj = moment_timezone_1.default.tz(timezoneIdentifier);
    return {
        timezoneOffsetToText: dateTimeObj.format('Z'),
        timezoneCode: dateTimeObj.format('z'),
        utcOffsetInHours: dateTimeObj.utcOffset() / 60,
    };
};
exports.getTimezoneInformation = getTimezoneInformation;
const getTimeZoneOffsetText = (zone) => {
    return (0, exports.getTimezoneInformation)(zone).timezoneOffsetToText;
};
exports.getTimeZoneOffsetText = getTimeZoneOffsetText;
const getTimeZoneWithOffsetString = (timeZone, offset) => {
    return `(GMT${offset}) ${timeZone}`;
};
exports.getTimeZoneWithOffsetString = getTimeZoneWithOffsetString;
const getTimeZones = () => {
    return Object.entries(customTimezoneList_1.customTimezoneList)
        .map(([timeZone, label]) => {
        const offsetInHours = (0, exports.getTimezoneInformation)(timeZone).utcOffsetInHours;
        const offsetText = (0, exports.getTimeZoneOffsetText)(timeZone);
        return {
            offset: offsetInHours,
            timeZone,
            timeZoneWithOffset: (0, exports.getTimeZoneWithOffsetString)(label, offsetText),
        };
    })
        .sort((a, b) => a.offset - b.offset);
};
exports.getTimeZones = getTimeZones;
const TimezoneSelector = ({ onOptionSelect, value }) => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const autocompleteOptions = (0, exports.getTimeZones)().map((timezone) => ({
        value: timezone.timeZone,
        text: timezone.timeZoneWithOffset,
    }));
    const options = autocompleteOptions;
    const selectedValueObject = autocompleteOptions.find((option) => option.value === value);
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Autocomplete, { value: selectedValueObject, options: options, getOptionLabel: (timezone) => timezone.text, onOptionSelect: onOptionSelect, label: translate(translations_1.timezoneTranslations.inputLabel), TextFieldProps: {
            fullWidth: false,
            style: { minWidth: '40vw' },
            inputProps: {
                'data-tracking-id': trackingIds.timeZoneSelector,
            },
        }, disableClearable: true }));
};
exports.TimezoneSelector = TimezoneSelector;
//# sourceMappingURL=TimezoneSelector.js.map